var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSgd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3681)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_3681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_3681)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V11.5H23V0H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37417 10.1485C6.37417 10.1485 4.34321 9.05937 4.34321 6.10859C4.34321 3.15781 6.37417 2.10386 6.37417 2.10386C5.38709 1.77068 2.76788 2.06868 2.76788 6.10859C2.76788 10.1485 5.34751 10.9104 6.37417 10.1485ZM6.89453 9.66077L7.47717 9.19178L8.07264 9.66077L7.92691 8.74559L8.41098 8.02364H7.75512L7.47717 7.1691L7.19921 8.02364L6.54223 8.06068L7.02743 8.74559L6.89453 9.66077ZM9.59482 9.13941L9.01218 9.6084L9.14508 8.69322L8.65988 8.00831L9.31686 7.97127L9.59482 7.11673L9.87277 7.97127H10.5286L10.0446 8.69322L10.1903 9.6084L9.59482 9.13941ZM8.11265 5.52962L8.69529 5.06064L9.29076 5.52962L9.14503 4.61445L9.6291 3.8925H8.97324L8.69529 3.03796L8.41733 3.8925L7.76035 3.92953L8.24555 4.61445L8.11265 5.52962ZM6.73454 6.92188L6.15191 7.39086L6.2848 6.47569L5.79961 5.79077L6.45659 5.75374L6.73454 4.8992L7.0125 5.75374H7.66836L7.18428 6.47569L7.33002 7.39086L6.73454 6.92188ZM10.0033 7.34883L10.5859 6.87985L11.1814 7.34883L11.0356 6.43366L11.5197 5.71171H10.8639L10.5859 4.85717L10.3079 5.71171L9.65097 5.74875L10.1362 6.43366L10.0033 7.34883Z",
    fill: "#F1F9FF"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3681)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3681",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgd);
export default __webpack_public_path__ + "static/media/SGD.e0fc219ce0180dcf1b72f83e2efb95b2.svg";
export { ForwardRef as ReactComponent };